import React from "react";


export default function TabItem({ tab, index, activeTabHandler }) {
 

  return (
    <li
      onClick={() => activeTabHandler(index)}
      className={`${tab.active ? "active-tab" : ""} ${tab.className || ""}`}
    >
      {tab.name}{tab.count !== undefined ? <span className="tab-count">{tab.count}</span> : ""}
   
    </li>
  );
}
